import { generateUniqueViewId } from '../lib/mobx-utils';

export class BaseEntity {
  public vid = generateUniqueViewId();
}
